<ng-container
  *ngTemplateOutlet="useNewDesign ? newDesign : oldDesign;">
</ng-container>

<!-- "Next available at" click: confirm the new pickup time before applying it. -->
<ngx-smart-modal #confirmPickupUpdateModal identifier="confirmPickupUpdateModal{{instanceId}}"
  customClass="payment-preauth-model nsm-dialog-animation-ttb"
  (onDismiss)="confirmPickupUpdateModal.close()">
  <h3 [innerHTML]="'confirm_update_pickup_title' | translate | ucFirst"></h3>
  <span [innerHTML]="('confirm_update_pickup_text' | translate | ucFirst).replace('{time}', formatNextAvailable(pendingNextAvailableProduct))"></span>
  <div class="wb-container" style="padding-top:10px;">
    <button class="wb-button-small" (click)="confirmPickupUpdateModal.close()">
      {{ 'no' | translate | ucFirst }}
    </button>
    <button class="wb-button-small"
      (click)="acceptNextAvailableSlot();confirmPickupUpdateModal.close();">
      {{ 'yes' | translate | ucFirst }}
    </button>
  </div>
</ngx-smart-modal>

<ng-template #bookingSummary>
  @if (hasBookingSummary()) {
    <div class="wb-booking-summary">
      <div class="wb-booking-summary-content">
        @if (requestedDateDisplay || passengerCount || luggageCount) {
          <div class="wb-booking-summary-meta"
            >
            <span class="wb-booking-summary-dot" aria-hidden="true"></span>
            <span class="wb-booking-summary-items">
              @if (requestedDateDisplay) {
                <span class="wb-booking-summary-item wb-booking-summary-date">{{ requestedDateDisplay }}</span>
              }
              @if (passengerCount) {
                <span class="wb-booking-summary-item">{{ passengerCount }} {{ 'passengers' | translate | ucFirst }}</span>
              }
              @if (luggageCount) {
                <span class="wb-booking-summary-item">{{ luggageCount }} {{ 'luggage' | translate | ucFirst }}</span>
              }
            </span>
          </div>
        }
        @if (addressList.length) {
          <div class="wb-booking-summary-route">
            <span class="wb-booking-summary-dot" aria-hidden="true"></span>
            <span class="wb-booking-summary-addresses">
              @for (address of addressList; track address; let isLast = $last) {
                <span class="wb-booking-summary-address">{{ address }}</span>
                @if (!isLast) {
                  <span class="wb-booking-summary-arrow" aria-hidden="true">→</span>
                }
              }
            </span>
          </div>
        }
      </div>
      @if (quotationEnabled) {
        <button type="button" class="wb-quote-card-button"
        (click)="requestQuoteFromSummary()">{{ 'request_quote_button' | translate | ucFirst }}</button>
      }
    </div>
  }
</ng-template>

<ng-template #oldDesign let-data="data">
  <div
    class="wb-product-selection-wrapper {{(returnTrip ? 'wb-product-selection-active-return' : '')}}  {{(returnTripCompleted ? 'wb-product-selection-active-return-completed' : '')}} wb-{{layout}}">
    <div class="wb-product-selection-products {{(returnTrip ? 'wb-limitHeight' : '')}}">
      <ng-container *ngTemplateOutlet="bookingSummary"></ng-container>
      @for (product of products; track product) {
        <div class="wb-product-selection-product" [class.wb-product-selection-product-unavailable]="product.available === false">
          <div class="wb-product-selection-meta">
            <img src="{{product.imagePath}}" alt="{{product.name}}">
            <h3>{{ product.descriptionTag | translate | ucFirst }}</h3>
            @if (!this.form.config.hideMaxPassenger) {
              <p
              >{{ 'max' | translate | ucFirst }} {{ product.maxPassengers }} {{ 'passengers_short' | translate | ucFirst }}</p>
            }
            @if (product.extraInfo) {
              <p>{{ product.extraInfo }}</p>
            }
            @if (product.extraDescription) {
              <p>{{ product.extraDescription }}</p>
            }
          </div>
          @if (product.available === false) {
            <div class="wb-product-selection-prices wb-product-unavailable-pane">
              <span class="wb-unavailable-label">{{ 'product_unavailable' | translate | ucFirst }}</span>
              @if (product.nextAvailableAt) {
                <a href="javascript:void(0)"
                  class="wb-next-available-slot"
                  (click)="confirmNextAvailableSlot(product)">
                  {{ 'product_next_available_at' | translate | ucFirst }} {{ formatNextAvailable(product) }}
                </a>
              }
            </div>
          }
          @if (product.available !== false) {
            <div class="wb-product-selection-prices">
              <div class="wb-product-selection-price">
                <span>
                  <div>
                    <span
                      class="wb-product-selection-type">{{
                      (this.form.config.orderType === 'hourly' ? 'total' :
                      'product_button_one_way') | translate | ucFirst
                    }}</span>
                  </div>
                  <div>
                    @if (product.price.total>0) {
                      <span class="wb-product-selection-amount">
                        {{
                        (product.currencySymbol ? product.currencySymbol :
                        'currency_symbol_' + product.price.currency.toLowerCase() | translate | ucFirst)
                        }}
                        {{ product.price.total / 100 | number:'1.2-2' }}
                      </span>
                    }
                    @if (!product.price || !product.price.total) {
                      <span class="wb-product-selection-onmeter"
                      >{{ 'onmeter' | translate | ucFirst }}</span>
                    }
                  </div>
                </span>
                <a href="javascript:void(0)"
                (click)="selectProduct(product)">{{ 'product_button_book' | translate | ucFirst }}</a>
              </div>
              @if (formGroup.controls.destinationModel &&
                formGroup.controls.destinationModel.value && this.showReturn && this.form.config.orderType === 'route') {
                <div class="wb-product-selection-price">
                  <span>
                    <div>
                      <span class="wb-product-selection-type">{{ 'product_button_return_trip' | translate | ucFirst }}</span>
                    </div>
                    <div>
                      @if (product.totalPrice && product.totalPrice.total>0) {
                        <span class="wb-product-selection-amount">
                          {{
                          (product.currencySymbol ? product.currencySymbol :
                          'currency_symbol_' + product.totalPrice.currency.toLowerCase() | translate | ucFirst)
                          }}
                          {{ product.totalPrice.total / 100 | number:'1.2-2' }}
                        </span>
                      }
                      @if (!product.totalPrice ||!product.totalPrice.total) {
                        <span class="wb-product-selection-onmeter">{{
                          'onmeter' | translate |
                          ucFirst
                        }} </span>
                      }
                    </div>
                  </span>
                  <a href="javascript:void(0)"
                  (click)="selectProduct(product, true)">{{ 'product_button_book' | translate | ucFirst }}</a>
                </div>
              }
              @if (this.productSummery && !this.forceSummaryTag && product.description) {
                <div class="wb-product-selection-extra-details-sub-section"
                [innerHTML]="product.description | translate | html"></div>
              }
              @if (!this.forceSummaryTag && product.extraInfo && this.productExtraDescription && product.description) {
                <div class="wb-product-selection-extra-details-sub-section"
                  [innerHTML]="'<ul><li>'+product.description+'</li></ul>' | html"></div>
                }
                @if (this.forceSummaryTag && product.extraInfo) {
                  <div class="wb-product-selection-extra-details-sub-section"
                  [innerHTML]="product.summaryTag | translate | html"></div>
                }
              </div>
            }
            <div class="wb-product-selection-break"></div>
            @if (this.forceSummaryTag && !product.extraInfo) {
              <div class="wb-product-selection-extra-details"
              [innerHTML]="product.summaryTag | translate | html"></div>
            }
            @if (!this.forceSummaryTag && !product.extraInfo && !this.productSummery && this.productExtraDescription && product.description) {
              <div class="wb-product-selection-extra-details"
                [innerHTML]="'<ul><li>'+product.description+'</li></ul>' | html"></div>
              }
            </div>
          }
        </div>

        <div class="wb-product-selection-return {{(returnTrip ? 'product-selection-show' : '')}}">
          <div class="wb-product-selection-text">
            <p>{{ 'return_trip_details_text' | translate | ucFirst }}</p>
          </div>
          <app-field-wrapper [className]="'field address'"
            [summary]="true"
            [index]="9999"
            [field]="returnDepartureField"
            [formGroup]="formGroup"
            [mainConfig]="this.form.config"
            [returnTrip]="true"
          (openHelpModal)="openHelpModal.emit($event)"></app-field-wrapper>
          @if (returnDestinationField) {
            <app-field-wrapper
              [className]="'field address'"
              [summary]="true"
              [index]="9999"
              [field]="returnDestinationField"
              [formGroup]="formGroup"
              [returnTrip]="true"
              [mainConfig]="this.form.config"
            (openHelpModal)="openHelpModal.emit($event)"></app-field-wrapper>
          }
          @for (field of fields; track field; let fi = $index) {
            @if (!field.hidden) {
              <app-field-wrapper
                [className]="'field '+field.type"
                [index]="fi"
                [field]="field"
                [minimumOrderTime]="minimumOrderTime"
                [returnTrip]="true"
                [formGroup]="formGroup"
                [mainConfig]="this.form.config"
              (openHelpModal)="openHelpModal.emit($event)"></app-field-wrapper>
            }
          }
        </div>
      </div>
    </ng-template>

    <ng-template #newDesign>
      <div
        class="wb-product-selection-wrapper {{(returnTrip ? 'wb-product-selection-active-return' : '')}}  {{(returnTripCompleted ? 'wb-product-selection-active-return-completed' : '')}} wb-{{layout}}">
        <div class="wb-product-selection-new">
          <ng-container *ngTemplateOutlet="bookingSummary"></ng-container>
          @for (product of products; track product) {
            <div class="wb-product-selection-product">
              <div class="wb-product-card" [class.wb-product-card-unavailable]="product.available === false">
                <div class="wb-product-image-pane">
                  <img [src]="product.imagePath" alt="{{ product.name }}" class="wb-product-image"/>
                </div>
                <div class="wb-product-info">
                  <h3>{{ product.descriptionTag | translate | ucFirst }}</h3>
                  <p>
                    @if (product.maxPassengers) {
                      <span class="wb-product-info-passenger"><span class="wb-count">{{ product.maxPassengers }}</span> <span class="wb-unit">{{ 'passengers' | translate | ucFirst }}</span></span>
                    }
                    @if (product.maxLuggage) {
                      <span class="wb-product-info-luggage"><span class="wb-count">{{ product.maxLuggage }}</span> <span class="wb-unit">{{ 'luggage_items' | translate | ucFirst }}</span></span>
                    }
                    @if (product.extraInfo && !product.description) {
                      <span class="wb-extra-info">{{ product.extraInfo }}</span>
                    }
                    @if (product.description) {
                      <span class="wb-extra-info" [innerHTML]="product.description | html"></span>
                    }
                  </p>
                </div>
                @if (product.available !== false) {
                  <div class="product-pricing">
                    <div class="price-row" (click)="selectProduct(product, false)">
                      <span class="wb-type">
                        {{
                        (this.form.config.orderType === 'hourly'
                        ? 'total'
                        : 'product_button_one_way') | translate | ucFirst
                        }}
                      </span>
                      @if (product.price.total > 0) {
                        <span class="wb-amount">
                          {{
                          (product.currencySymbol
                          ? product.currencySymbol
                          : 'currency_symbol_' + product.price.currency.toLowerCase()
                          | translate | ucFirst)
                          }}
                          {{ product.price.total / 100 | number: '1.2-2' }}
                        </span>
                      }
                      @if (!product.price || !product.price.total) {
                        <span class="onmeter">{{
                          'onmeter' | translate | ucFirst
                        }}</span>
                      }
                    </div>
                    @if (showReturn && form.config.orderType === 'route') {
                      <div class="price-row" (click)="selectProduct(product, true)">
                        <span class="wb-type">{{ 'product_button_return_trip' | translate }}</span>
                        @if (product.totalPrice && product.totalPrice.total > 0) {
                          <span class="wb-amount">
                            {{
                            (product.currencySymbol
                            ? product.currencySymbol
                            : 'currency_symbol_' + product.totalPrice.currency.toLowerCase()
                            | translate | ucFirst)
                            }}
                            {{ product.totalPrice.total / 100 | number: '1.2-2' }}
                          </span>
                        }
                        @if (!product.totalPrice || !product.totalPrice.total) {
                          <span class="onmeter">{{
                            'onmeter' | translate | ucFirst
                          }}</span>
                        }
                      </div>
                    }
                  </div>
                }
                @if (product.available === false) {
                  <div class="product-pricing wb-product-unavailable-pane">
                    <span class="wb-unavailable-label">{{ 'product_unavailable' | translate | ucFirst }}</span>
                    @if (product.nextAvailableAt) {
                      <a href="javascript:void(0)"
                        class="wb-next-available-slot"
                        (click)="confirmNextAvailableSlot(product)">
                        {{ 'product_next_available_at' | translate | ucFirst }} {{ formatNextAvailable(product) }}
                      </a>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="wb-product-selection-return {{(returnTrip ? 'product-selection-show' : '')}}">
          <div class="wb-product-selection-text">
            <p>{{ 'return_trip_details_text' | translate | ucFirst }}</p>
          </div>
          <app-field-wrapper [className]="'field address'"
            [summary]="true"
            [index]="9999"
            [field]="returnDepartureField"
            [formGroup]="formGroup"
            [mainConfig]="this.form.config"
            [returnTrip]="true"
          (openHelpModal)="openHelpModal.emit($event)"></app-field-wrapper>
          @if (returnDestinationField) {
            <app-field-wrapper
              [className]="'field address'"
              [summary]="true"
              [index]="9999"
              [field]="returnDestinationField"
              [formGroup]="formGroup"
              [returnTrip]="true"
              [mainConfig]="this.form.config"
            (openHelpModal)="openHelpModal.emit($event)"></app-field-wrapper>
          }
          @for (field of fields; track field; let fi = $index) {
            @if (!field.hidden) {
              <app-field-wrapper
                [className]="'field '+field.type"
                [index]="fi"
                [field]="field"
                [minimumOrderTime]="minimumOrderTime"
                [returnTrip]="true"
                [formGroup]="formGroup"
                [mainConfig]="this.form.config"
              (openHelpModal)="openHelpModal.emit($event)"></app-field-wrapper>
            }
          }
        </div>
      </div>
    </ng-template>
